import styled from 'styled-components';

import { Link } from "react-router-dom"
export const CantainerNavbar = styled.div`
  max-width: ${(prop) => prop.open === true ? (prop.onlyWidth < 1100 ? "100%" : 'auto') : '70px'};
  background-color: #FFFFFF;
  width: auto;
  box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
  padding: 8px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 97vh;
  z-index:999;

  @media only screen and (min-width:0px) and (max-width:1100px){
    position:fixed;
    z-index:999;
    min-width:100%;
    height: ${(prop) => prop.open === true ? (prop.onlyWidth < 1100 ? "100%" : '35px ') : '35px '};
    padding: 15px 0px 0px 0px;
  }

`;
export const IconItem = styled.img`
  width:24px;
  height:24px;
  min-height:24px;
  min-width:24px;
`;

export const LogoNavbar = styled.img`
  width: 100%;
  height: auto;
  padding: 5px 16px;
`;

export const ContainerListTextLink = styled.div`
  width: -webkit-fill-available;
  height: auto;
  display:flex;
  flex-direction:column;
  gap:4px;
  margin-top: 15px;
  @media only screen and (min-width: 0px) and (max-width: 1100px) {
    display: ${(props) => props.open && props.onlyWidth < 1100 ? "flex" : "none"};
  }
`;

export const ButtonRedirectLink = styled(Link)`
  font-family: 'Montserrat',sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #03324c;
  text-decoration: none;
  outline: none;
  transition: all 0s;
  padding: 5px 22px;
  border: 2px solid transparent;
  justify-content: flex-start;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  border-radius: 8px;
  gap: 8px;
  &:hover {
    background-color: #e0e2e7;
    filter: brightness(0.5);
  }
`;